import type { ActivePageView } from '@/types';

export function pathForView(view: ActivePageView, vehicleId?: string): string {
  switch (view) {
    case 'home':
      return '/';
    case 'vehicles':
      return '/vehicles';
    case 'vehicle-detail':
      return vehicleId ? `/vehicles/${encodeURIComponent(vehicleId)}` : '/vehicles';
    case 'locations':
      return '/locations';
    case 'deals':
      return '/deals';
    case 'services':
      return '/services';
    case 'about':
      return '/about';
    case 'contact':
      return '/contact';
    case 'faq':
      return '/faq';
    case 'privacy':
      return '/legal/privacy';
    case 'terms':
      return '/legal/terms';
    case 'profile':
      return '/account';
    default: {
      const unreachable: never = view;
      return unreachable;
    }
  }
}

export function viewFromPath(pathname: string): ActivePageView {
  if (pathname === '/' || pathname === '') return 'home';
  if (pathname === '/vehicles') return 'vehicles';
  if (/^\/vehicles\/[^/]+$/.test(pathname)) return 'vehicle-detail';
  if (pathname === '/locations') return 'locations';
  if (pathname === '/deals') return 'deals';
  if (pathname === '/services') return 'services';
  if (pathname === '/about') return 'about';
  if (pathname === '/contact') return 'contact';
  if (pathname === '/faq') return 'faq';
  if (pathname === '/legal/privacy') return 'privacy';
  if (pathname === '/legal/terms') return 'terms';
  if (pathname === '/account') return 'profile';
  return 'home';
}

/**
 * Paths owned by the built-in storefront. A builder page may not take these
 * over; the reserved-slug validation rejects them when a page is created.
 */
export function isBuiltInPath(pathname: string): boolean {
  if (pathname === '/' || pathname === '') return true;
  if (pathname === '/vehicles') return true;
  if (/^\/vehicles\/[^/]+$/.test(pathname)) return true;
  return (
    pathname === '/locations' ||
    pathname === '/deals' ||
    pathname === '/services' ||
    pathname === '/about' ||
    pathname === '/contact' ||
    pathname === '/faq' ||
    pathname === '/legal/privacy' ||
    pathname === '/legal/terms' ||
    pathname === '/account'
  );
}

export function vehicleIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/vehicles\/([^/]+)$/);
  if (!match) return null;
  return decodeURIComponent(match[1]);
}
